<template>
    <b-sidebar
        id="award-form-sidebar"
        :visible="isAwardFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(awardData)"
        @change="(val) => $emit('update:is-award-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div
                class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
            >
                <h5 class="mb-0">Award Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="close(hide)"
                />
            </div>
            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                >
                    <b-tabs v-model="tabIndex">
                        <b-tab
                            v-for="(lang, key) in langs"
                            :key="'tab-' + key"
                            :title="lang.name"
                        >
                            <validation-provider
                                #default="validationContext"
                                :name="'title_' + lang.code"
                                rules="required"
                            >
                                <b-form-group
                                    label="Title"
                                    :label-for="'title_' + lang.code"
                                >
                                    <b-form-input
                                        :id="'title_' + lang.code"
                                        v-model="Data.title[lang.code]"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'title (' + lang.code + ')'"
                                    />
                                    <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <hr/>
                            <draggable v-model="Data.details" tag="ul" hadle=".handle">
                                <b-row v-for="(item, index) in Data.details" :key="index" align-v="center">
                                    <b-col cols="0">
                                        <th scope="row" class="pl-2 ">
                                            <feather-icon size="24" icon="MenuIcon"/>
                                        </th>
                                    </b-col>
                                    <b-col cols="5">
                                        <validation-provider
                                            #default="validationContext"
                                            :name="'certificate_' + lang.code"
                                        >
                                            <b-form-group
                                                label="Certificate"
                                                :label-for="'certificate_' + lang.code"
                                            >
                                                <quill-editor
                                                    :options="editorOptions"
                                                    :id="'certificate_' + lang.code"
                                                    v-model="item.certificate[lang.code]"
                                                />
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col cols="5">
                                        <validation-provider
                                            #default="validationContext"
                                            :name="'certificate detail_' + lang.code"
                                        >
                                            <b-form-group
                                                label="Certificate Detail"
                                                :label-for="'certificate detail_' + lang.code"
                                            >
                                                <quill-editor
                                                    :options="editorOptions"
                                                    :id="'certificate detail_' + lang.code"
                                                    v-model="item.certificate_detail[lang.code]"
                                                />
                                                <b-form-invalid-feedback>
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col
                                        class="mb-50"
                                    >
                                        <b-button
                                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                            variant="outline-danger"
                                            class="mt-0 mt-md-2"
                                            @click="removeItem(index)"
                                        >
                                            <feather-icon
                                                icon="XIcon"
                                                class="mr-25"
                                            />
                                            <span>Delete</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </draggable>
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                @click="repeateAgain"
                            >
                                <feather-icon
                                    icon="PlusIcon"
                                    class="mr-25"
                                />
                                <span>Add Certificate</span>
                            </b-button>
                        </b-tab>
                    </b-tabs>
                    <div class="d-flex mt-2">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="outline-success"
                          class="mr-2"
                          type="submit"
                        >
                          Save
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          type="button"
                          variant="outline-danger"
                          @click="close(hide)"
                        >
                          Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>
    
<script>
    import { $themeConfig } from '@themeConfig'
    import {
        BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
        BButton, BTabs, BTab, BCard, BCardText, BFormRadio, BFormRadioGroup, BFormCheckboxGroup, BContainer,
        BRow, BCol
    } from "bootstrap-vue";
    import vSelect from "vue-select";
    import { required, alphaNum, email, password,confirmed } from '@validations'
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { quillEditor } from "vue-quill-editor";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.bubble.css";
    import Quill from 'quill'
    const sizeStyle = Quill.import('attributors/style/size')
    sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
    Quill.register(sizeStyle, true)
    import { useToast } from "vue-toastification/composition";
    import { ref, onUnmounted, computed } from "@vue/composition-api";
    import Ripple from "vue-ripple-directive";
    import store from "@/store";
    import draggable from 'vuedraggable';
    import formValidation from "@core/comp-functions/forms/form-validation";
    import languagesStoreModule from "@/views/languages/languagesStoreModule"
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    
    export default {
        components: {
            BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
            BButton, BTabs, BTab, BCard, BCardText, vSelect, ValidationProvider,
            ValidationObserver, BFormRadio, quillEditor, BFormRadioGroup, BFormCheckboxGroup,
            BContainer, BRow, BCol, draggable,
        },
    
        directives: {
            Ripple,
        },
    
        model: {
            prop: "isAwardFormSidebarActive",
            event: "update:is-award-form-sidebar-active",
        },
    
        props: {
            isAwardFormSidebarActive: {
                type: Boolean,
                required: true,
            },
            awardData: {
                type: Object,
                required: false,
            },
        },

        computed: {
            currentLocale(){
                return this.$i18n.locale;
            },
            editorOptions (){
                return $themeConfig.snowOption
            }
        },
    
        setup(props, { emit }){
            const {  appRef } = $themeConfig.app
            const LANGUAGES_STORE_MODULE_NAME = "app-languages";
            if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME))
            store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
            onUnmounted(() => {
                if (store.hasModule(LANGUAGES_STORE_MODULE_NAME))
                store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
            });
    
            const toast = useToast();
            const userStorage = JSON.parse(localStorage.getItem('userData'));
            const getLocalSite = JSON.parse(localStorage.getItem('site'))
            const blankData = {
                id: '',
                title: {},
                details: [],
                is_active: true,
                ordering_count: 0,
                sites_id: getLocalSite.id,
                created_by: userStorage.id,
            };
            const Data = ref(blankData);
            const tabIndex = ref(0);
            const langs = ref([]);
            const oldValue  =  ref(null)
    
            const getData = async function(data){
                tabIndex.value = 0;
    
                if(data!=null){
                    data.is_active = data.is_active? true: false
    
                    Data.value = data
    
                    oldValue.value = JSON.parse(JSON.stringify({...data}))
                } else {
                    const blankData = {
                        id: '',
                        title: {},
                        details: [],
                        is_active: true,
                        ordering_count: 0,
                        sites_id: getLocalSite.id,
                        created_by: userStorage.id,
                    }
    
                    Data.value = blankData
                }
            }
    
            const onSubmit = function () {
                Data.value.is_active = Data.value.is_active ? 1 : 0;
    
                if(Data.value.id){
                    store.dispatch('app-award/updateAward', Data.value)
                        .then(res => {
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `Success`,
                                    icon: 'BellIcon',
                                    variant: 'success',
                                    text: `${res.data.message}`,
                                },
                            });
    
                            emit('refetch-data')
                            emit('update:is-award-form-sidebar-active', false)
                        })
                        .catch((error) => {
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: "Error",
                                    icon: 'AlertTriangleIcon',
                                    variant: 'danger',
                                    text: `${error?.response?.data?.message??'Something went wrong'}`,
                                },
                            })
                        })
                } else {
                    store.dispatch('app-award/addAward', Data.value)
                        .then(res => {
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `Success`,
                                    icon: 'BellIcon',
                                    variant: 'success',
                                    text: `${res.data.message}`,
                                },
                            });
    
                            emit('refetch-data')
                            emit('update:is-award-form-sidebar-active', false)
                        })
                        .catch((error) => {
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: "Error",
                                    icon: 'AlertTriangleIcon',
                                    variant: 'danger',
                                    text: `${error?.response?.data?.message??'Something went wrong'}`,
                                },
                            })
                        })
                }
            }
    
            const resetData = () => {
                Data.value.title = {}
                Data.value.details = []
            };
    
            const getLangs = (filter) => {
                store.dispatch("app-languages/fetchData", filter).then((res) => {
                    if (res.data.success) {
                        langs.value = res.data.data;
                    }
                });
            };
    
            let filter = {
                is_active:1,
            }
    
            getLangs(filter);
    
            const close = (hidden) => {
                for(const lang in oldValue.value?.title ?? {}) {
                    Data.value.title[lang] = oldValue.value.title[lang]
                }
    
                hidden()
            }
    
            const {
                resetForm,
                getValidationState,
                refFormObserver
            } = formValidation(resetData);
    
            const refeshList = async () => {
                emit("refetch-data");
            };
    
            return {
                refeshList,
                resetData,
                resetForm,
                getData,
                tabIndex,
                langs,
                getLangs,
                getValidationState,
                Data,
                close,
                onSubmit,
                refFormObserver,
                oldValue,
            }
        },
    
        methods: {
            repeateAgain() {
                this.Data.details.push({
                    certificate: {},
                    certificate_detail: {},
                });
            },
    
            removeItem(index) {
                this.Data.details.splice(index, 1);
            },
      }
    }
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";
</style>
    
    